<template>
  <div v-if="loading" class="fixed inset-0 flex items-center justify-center bg-white">
    <div class="text-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-zebu-orange mx-auto"></div>
      <div class="mt-4 text-gray-600">Chargement...</div>
    </div>
  </div>
  <div v-else-if="error" class="fixed inset-0 flex items-center justify-center">
    <div class="error-message mx-4">{{ error }}</div>
  </div>
  <router-view v-else />
</template>

<script setup>
import { ref, onMounted } from 'vue'

const loading = ref(true)
const error = ref(null)

onMounted(async () => {
  try {
    await new Promise(resolve => setTimeout(resolve, 500))
    loading.value = false
  } catch (e) {
    error.value = "Une erreur est survenue lors du chargement de l'application"
    loading.value = false
  }
})
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>